{
  "links" : {
    "triggerLinksDescription" : "Triggerilinkit Ottaa käyttöön Sinä/Te laita linkit Sisempi SMS ja Gmail, jotka Ottaa ottaa käyttöön Sinä/Te seurataksesi tiettyjä asiakastoimintoja ja käynnistää tapahtumat-pohjainen Päällä Kun Linkkiä napsautetaan.",
    "enterName" : "Anna nimi",
    "enterLinkURL" : "Anna Linkin URL-osoite",
    "save" : "Arkistoida",
    "cancel" : "Peruuttaa",
    "delete" : "Poista",
    "aboutToDeleteLink" : "`Sinä/Te're – jos haluat poistaa ${deleteRowName} aloittaaä Linkki. Poistettu Linkkiä ei voi palauttaa, haluatko Sinä/Oletko varmasti Sinä/Te Jatkaan?`",
    "noTriggerLinksFound" : "Ei Triggerilinkitittyä",
    "getStartedByAddingNewTriggerLinks" : "Aloita Kautta lisäämällä uudet Triggerilinkit",
    "newTriggerLink" : "Uusi triggeri Linkki",
    "searchNoMatch" : "Hakeasi ei vastannut mitään aloiä Linkki.",
    "link" : "Linkki",
    "addLink" : "Lisätä Linkki",
    "linkURL" : "Linkin URL-osoite",
    "name" : "Nimi",
    "pleaseEnterNonEmptyLinkName" : "Anna Linkki-nimi, joka ei ole tyhjä",
    "pleaseEnterURL" : "Anna URL-osoite",
    "actions" : "toiminnot",
    "linkKey" : "Linkki Avain-",
    "keyCopied" : "Avain- Kopioitu"
  }
}
